module.exports = __webpack_public_path__ + "media/fonts/Unica77LLTT-Bold-48558ca6a3843b713b78cc94edd1a195.woff";